export const translations = {
  en: {
    // Navbar
    nav: {
      home: 'Home',
      about: 'About',
      firstCryptoFund: 'First Crypto Fund',
      blog: 'Blog',
      contact: 'Contact',
      bookConsultation: 'Book Consultation',
    },
    
    // Home page
    home: {
      heroTitle: 'Investing',
      heroTitleGold: 'in Crypto',
      heroDescription: 'Invest in three EU registered alternative crypto funds. Enables easy and regulated entry on crypto market through a single transaction.',
      featureProfessional: 'Professional management',
      featurePromising: 'Promising crypto selection',
      featureLowCosts: 'Low costs',
      featureSecurity: 'High level of security',
      learnMore: 'Learn More',
      scrollToExplore: 'Scroll to explore',
      disclaimer: 'The investment funds are intended exclusively for professional investors.',
      
      // Features section
      whyChooseUs: 'Why Choose Us',
      feature1Title: 'Asset Management Company',
      feature1Desc: 'Authorized to manage alternative investment funds (AIFs), including investments in crypto assets, private equity, and hedge funds.',
      feature2Title: 'EU Based',
      feature2Desc: 'Fully compliant European company operating under strict EU regulatory framework for investor protection.',
      feature3Title: 'Virtual Currencies Services',
      feature3Desc: 'Licensed provider of virtual currency services including buying, selling, storing, and transferring crypto assets.',
      feature4Title: 'Broker Licenses A, B, C',
      feature4Desc: 'Comprehensive broker examinations and licenses for selling investment funds and securities trading.',
      feature5Title: 'Compliance & Security',
      feature5Desc: 'ECQA management, MiFID, DPO, GDPR, and AML certifications ensuring highest compliance standards.',
      feature6Title: 'Professional Investors',
      feature6Desc: 'Companies and professional investors can invest and purchase fund shares through our regulated platform.',
      
      // Funds section
      ourFunds: 'Our Investment Funds',
      threePaths: 'Three Paths to Crypto Investment',
      fund1Title: 'First Crypto Fund',
      fund1Desc: 'Professionally curated basket of established cryptocurrencies with proven track records and strong market positions.',
      fund1Feature1: 'Diversified portfolio',
      fund1Feature2: 'Professional custody',
      fund1Feature3: 'Monthly rebalancing',
      fund2Title: 'Hedge Fund',
      fund2Desc: 'Active trading strategies designed to generate returns in both bull and bear market conditions.',
      fund2Feature1: 'Active management',
      fund2Feature2: 'Risk-adjusted returns',
      fund2Feature3: 'Market neutral strategies',
      fund3Title: 'Best Crypto Index Fund',
      fund3Desc: 'Track the performance of the top cryptocurrencies with minimal management fees and maximum transparency.',
      fund3Feature1: 'Index tracking',
      fund3Feature2: 'Low fees',
      fund3Feature3: 'Transparent holdings',
      
      // Report section
      weeklyReport: 'Weekly Report',
      marketAnalysis: 'Market Analysis',
      readFullReport: 'Read Full Report',
      
      // CTA section
      readyToInvest: 'Ready to Invest in Crypto?',
      ctaDescription: 'Schedule a consultation to learn how our regulated crypto funds can help you achieve your investment goals.',
      bookFreeConsultation: 'Book Your Free Consultation',
    },

    // About page
    about: {
      seoTitle: 'About Us',
      seoDescription: 'FUTURE MONEY is an EU-based Asset Management Company for Alternative Investment Funds, headquartered in Ljubljana, Slovenia. Licensed to manage crypto investments.',
      
      companyName: 'FUTURE MONEY,',
      tagline1: 'Asset Management',
      tagline2: 'company for alternative',
      tagline3: 'investment funds.',
      
      profileTitle: 'Company Profile',
      profileText1: 'FUTURE MONEY, Asset Management company for alternative investment funds Ltd.,',
      profileAddress: 'Address: Dunajska cesta 101, 1000 Ljubljana, Slovenia',
      profileText2: 'Was established in 2019 and is registered at supervisory authority: The Securities Market Agency, Slovenia (ATVP, Agencija za trg vrednostnih papirjev,',
      profileText3: 'FUTURE MONEY is registered virtual currencies service provider.',
      
      identificationNumber: 'Identification number',
      taxNumber: 'Tax number',
      lei: 'LEI',
      
      teamTitle: 'Meet the Director',
      teamDescription: 'An experienced entrepreneur, trader, and expert in financial investments. My utmost priority is the satisfaction of our investors, which brings me great joy.',
      directorRole: 'Director',
      directorBio: 'Crypto is an opportunity for all! Experienced CEO, lecturer, international entrepreneur, creative financial product creator, financial team leader. Excited about the amazing opportunities that modern technologies bring. International supplier of precious metals and diamonds.',
    },

    // Contact page
    contact: {
      seoTitle: 'Contact Us',
      seoDescription: 'Contact FUTURE MONEY for crypto investment inquiries. Schedule a consultation to discuss your investment goals. Located in Ljubljana, Slovenia.',
      
      getInTouch: 'Get In Touch',
      heroTitle: "Let's Discuss Your",
      heroTitleGold: 'Investment Goals',
      heroDescription: 'Ready to explore regulated crypto investment opportunities? Contact us to schedule a consultation or learn more about our funds.',
      
      contactInfo: 'Contact Information',
      contactInfoDesc: 'Reach out to us through any of the following channels. We typically respond within 24 business hours.',
      
      officeAddress: 'Office Address',
      email: 'Email',
      phone: 'Phone',
      linkedin: 'LinkedIn',
      followLinkedin: 'Follow us on LinkedIn',
      
      scheduleConsultation: 'Schedule a Consultation',
      scheduleDesc: 'Book a free consultation to discuss your investment needs.',
      bookNow: 'Book Now',
      
      sendMessage: 'Send us a Message',
      name: 'Name',
      yourName: 'Your name',
      yourEmail: 'your@email.com',
      subject: 'Subject',
      selectTopic: 'Select a topic',
      investmentInquiry: 'Investment Inquiry',
      fundInformation: 'Fund Information',
      partnership: 'Partnership',
      generalQuestion: 'General Question',
      other: 'Other',
      message: 'Message',
      howCanWeHelp: 'How can we help you?',
      sending: 'Sending...',
      sendMessageBtn: 'Send Message',
      formDisclaimer: 'By submitting this form, you agree to our privacy policy and consent to being contacted regarding your inquiry.',
      
      messageSent: 'Message Sent!',
      thankYou: "Thank you for contacting us. We'll get back to you within 24 business hours.",
      sendAnother: 'Send Another Message',
    },

    // First Crypto Fund page
    fcf: {
      seoTitle: 'First Crypto Fund',
      seoDescription: 'First Crypto Fund invests in cryptocurrencies that enable the generation of new coins using advanced approaches. High-risk, high-reward investment strategy.',
      
      fundNotice: 'The investment funds are intended exclusively for professional investors.',
      chartTitle: 'First Crypto Fund',
      chartSubtitle: '(FCF Chart)',
      loadingChart: 'Loading chart data...',
      noChartData: 'No chart data available yet.',
      navUsd: 'NAV (USD)',
      
      strategyTitle: 'Short strategy description:',
      strategyP1: 'First Crypto Fund invests in cryptocurrencies that enable the generation of new coins using advanced approaches.',
      strategyP2: 'Due to changing market conditions and volatility, the fund aims to generate higher returns with higher risk and volatility.',
      strategyP3: "The fund manager will diversify the fund's assets among cryptocurrencies, especially among selected promising cryptocurrencies, as well as various types of crypto investments with the goal of achieving a higher return.",
      strategyP4: 'The fund management strategy is based on a thoughtful response to the dynamic conditions in the cryptocurrency markets, which often exhibit extreme volatility and instability. The goal of the strategy is to create attractive return opportunities for clients despite increased risk and volatility. In shaping and implementing the portfolio, we will employ a set of highly specialized and advanced approaches.',
      
      masternodesTitle: 'Masternodes',
      masternodesDesc: 'A key component of the strategy is the active use of masternodes. Masternodes are not just technical elements but represent a critical part of the cryptocurrency network. Besides their role in ensuring network security, they play a vital role in transaction validation, enhancing the reliability of the blockchain network. In return for storing and validating transactions, we will receive new (or additional) coins, potentially positively impacting the fund\'s returns.',
      
      stakingTitle: 'Staking',
      stakingDesc: 'The strategy also includes active participation in the staking process. This means locking a certain amount of cryptocurrency in a wallet for the purpose of supporting the credibility and confirmation of transactions in the network. This enables the profitability of our assets in the form of rewards or interest, contributing to the overall returns of the investment strategy.',
      
      yieldFarmingTitle: 'Yield Farming',
      yieldFarmingDesc: 'Within the strategy, we implement yield farming strategies. This involves lending or providing liquidity in decentralized financial protocols (decentralized finance). This approach allows us to gain returns in the form of new coins or interest on deposits, further contributing to potential investment returns.',
      
      vestingTitle: 'Vesting',
      vestingDesc: 'To reduce volatility and ensure long-term stability, we employ a vesting strategy where allocated amounts of cryptocurrency are released gradually over a specified period. This thoughtful approach enables better asset management and reduces exposure to market fluctuations.',
      
      lpTitle: 'Liquidity Pools (LP)',
      lpDesc: "The fund's assets are invested in liquidity pools or LPs, which operate within decentralized financial protocols. To enter these pools, we require USDC or USDT on one side and cryptocurrencies on the other side, enabling us to participate in liquidity pools. This strengthens the fund's return potential and allows us to leverage various investment opportunities.",
      
      advantagesTitle: 'Advantages of Active Management:',
      advantagesIntro: "Active management of our fund's assets offers numerous advantages, including:",
      
      advantage1Title: 'Portfolio Diversification:',
      advantage1Desc: 'Thoughtfully combining different investment approaches, including masternodes, staking, yield farming, vesting, and LP investments, allows us to create a well-diversified portfolio. This reduces risk and increases the potential for profitability.',
      
      advantage2Title: 'Passive Income Generation:',
      advantage2Desc: 'Masternodes and staking enable passive generation of new coins, contributing to the potential for profitability.',
      
      advantage3Title: 'Long-Term Stability:',
      advantage3Desc: 'Strategies like vesting provide long-term portfolio stability, reducing exposure to market volatility.',
      
      advantage4Title: 'Flexibility:',
      advantage4Desc: 'Active management allows us to adjust the portfolio based on current market conditions and emerging opportunities, maintaining our ability to respond to market dynamics.',
      
      advantagesConclusion: 'With this comprehensive approach to active asset management, we aim to enable our fund to capitalize on opportunities in the cryptocurrency market and achieve higher returns despite increased risk and volatility in a well-considered and professional manner.',
      
      technicalTitle: 'Technical information about First Crypto Fund:',
      isinCode: 'ISIN code',
      securityCode: 'Security code',
      cfiGroup: 'CFI Group',
      cfiValue: 'Others (Miscellaneous) (CM)',
      leiCode: 'LEI code',
      registrationNumber: 'Registration number',
      taxNumber: 'Tax number',
      fundType: 'Fund type',
      fundTypeValue: 'open alternative investment fund',
      registeredIn: 'Registered in',
      registeredInValue: 'Slovenia (EU)',
      supervisoryAuthority: 'Supervisory authority',
      supervisoryValue: 'The Securities Market Agency, Slovenia (ATVP, Agencija za trg vrednostnih papirjev,',
      reporting: 'Reporting',
      reportingValue: 'The Securities Market Agency, Slovenia following the direct guidelines of European Securities and Markets Agency (ESMA)',
      risk: 'Risk',
      riskValue: 'High',
      investmentStrategy: 'Investment strategy',
      investmentStrategyValue: 'Other (crypto)',
      currency: 'Currency',
      currencyValue: 'US Dollar (USD)',
      minInvestment: 'Min. investment',
      entryFee: 'Entry fee',
      exitFee: 'Exit fee',
      transactionCost: 'Transaction cost',
      adminFee: 'Admin fee',
      managementFee: 'Management fee',
      otherFees: 'Other fees',
      profitSharing: 'Profit sharing',
      profitSharingValue: '60% to investors, 40% to the Fund Manager (High Water Mark, monthly calculation, quarterly reset)',
      cutOffDate: 'Cut-off date',
      cutOffDateValue: '(for calculation of VEP, deposits and withdrawals): last day in a month',
      
      paymentTitle: 'Payment instructions:',
      iban: 'IBAN',
      bicSwift: 'BIC / SWIFT',
      bank: 'Bank',
      manager: 'Manager',
      address: 'Address',
    },

    // Blog page
    blog: {
      seoTitle: 'Blog - Market Insights & Weekly Reports',
      seoDescription: "Stay informed with FUTURE MONEY's latest cryptocurrency market analysis, investment insights, and weekly Bitcoin and crypto reports.",
      
      ourBlog: 'Our Blog',
      heroTitle: 'Market Insights &',
      heroTitleGold: 'Weekly Reports',
      heroDescription: 'Stay informed with our latest market analysis, investment insights, and weekly cryptocurrency reports.',
      
      allPosts: 'All Posts',
      weeklyReports: 'Weekly Reports',
      marketAnalysis: 'Market Analysis',
      news: 'News',
      education: 'Education',
      
      loadingPosts: 'Loading posts...',
      noPostsFound: 'No posts found',
      checkBackSoon: 'Check back soon for new content.',
      readMore: 'Read More',
      
      // BlogPost page
      loadingPost: 'Loading post...',
      postNotFound: 'Post Not Found',
      postNotFoundDesc: "The post you're looking for doesn't exist or has been removed.",
      backToBlog: 'Back to Blog',
      backToAllPosts: 'Back to All Posts',
      views: 'views',
      share: 'Share',
      shareArticle: 'Share Article',
      linkCopied: 'Link copied to clipboard!',
    },

    // Footer
    footer: {
      description: 'Asset Management Company for Alternative Investment Funds, specializing in regulated crypto investment solutions for professional investors.',
      quickLinks: 'Quick Links',
      ourFunds: 'Our Funds',
      hedgeFund: 'Hedge Fund',
      bestCryptoIndex: 'Best Crypto Index Fund',
      contact: 'Contact',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      designedBy: 'Designed by Noctrify',
      allRightsReserved: 'All rights reserved.',
      disclaimer: 'The investment funds are intended exclusively for professional investors. Past performance is not indicative of future results.',
    },
  },
  
  sl: {
    // Navbar
    nav: {
      home: 'Domov',
      about: 'O nas',
      firstCryptoFund: 'Prvi kripto sklad',
      blog: 'Blog',
      contact: 'Kontakt',
      bookConsultation: 'Rezerviraj posvet',
    },
    
    // Home page
    home: {
      heroTitle: 'Investiranje',
      heroTitleGold: 'v kripto',
      heroDescription: 'Investirajte v tri v EU registrirane alternativne kripto sklade. Omogoča enostaven in reguliran vstop na kripto trg z eno samo transakcijo.',
      featureProfessional: 'Profesionalno upravljanje',
      featurePromising: 'Obetavna izbira kriptovalut',
      featureLowCosts: 'Nizki stroški',
      featureSecurity: 'Visoka raven varnosti',
      learnMore: 'Več informacij',
      scrollToExplore: 'Pomik navzdol za več',
      disclaimer: 'Investicijski skladi so namenjeni izključno profesionalnim vlagateljem.',
      
      // Features section
      whyChooseUs: 'Zakaj izbrati nas',
      feature1Title: 'Družba za upravljanje',
      feature1Desc: 'Pooblaščeni za upravljanje alternativnih investicijskih skladov (AIS), vključno z naložbami v kripto sredstva, zasebni kapital in hedge sklade.',
      feature2Title: 'Sedež v EU',
      feature2Desc: 'Popolnoma skladna evropska družba, ki deluje po strogem regulativnem okviru EU za zaščito vlagateljev.',
      feature3Title: 'Storitve virtualnih valut',
      feature3Desc: 'Licenciran ponudnik storitev virtualnih valut, vključno z nakupom, prodajo, hrambo in prenosom kripto sredstev.',
      feature4Title: 'Borznoposredniške licence A, B, C',
      feature4Desc: 'Celoviti borznoposredniški izpiti in licence za prodajo investicijskih skladov in trgovanje z vrednostnimi papirji.',
      feature5Title: 'Skladnost in varnost',
      feature5Desc: 'Certifikati ECQA management, MiFID, DPO, GDPR in AML zagotavljajo najvišje standarde skladnosti.',
      feature6Title: 'Profesionalni vlagatelji',
      feature6Desc: 'Podjetja in profesionalni vlagatelji lahko vlagajo in kupujejo deleže skladov prek naše regulirane platforme.',
      
      // Funds section
      ourFunds: 'Naši investicijski skladi',
      threePaths: 'Tri poti do kripto naložb',
      fund1Title: 'Prvi kripto sklad',
      fund1Desc: 'Profesionalno izbrana košarica uveljavljenih kriptovalut z dokazano uspešnostjo in močnimi tržnimi pozicijami.',
      fund1Feature1: 'Razpršen portfelj',
      fund1Feature2: 'Profesionalna hramba',
      fund1Feature3: 'Mesečno uravnoteženje',
      fund2Title: 'Hedge sklad',
      fund2Desc: 'Aktivne trgovalne strategije, zasnovane za ustvarjanje donosov v bikovskih in medvedjih tržnih razmerah.',
      fund2Feature1: 'Aktivno upravljanje',
      fund2Feature2: 'Donosnost prilagojena tveganju',
      fund2Feature3: 'Tržno nevtralne strategije',
      fund3Title: 'Najboljši kripto indeksni sklad',
      fund3Desc: 'Sledite uspešnosti najboljših kriptovalut z minimalnimi stroški upravljanja in maksimalno preglednostjo.',
      fund3Feature1: 'Sledenje indeksu',
      fund3Feature2: 'Nizke provizije',
      fund3Feature3: 'Pregledna imetja',
      
      // Report section
      weeklyReport: 'Tedensko poročilo',
      marketAnalysis: 'Tržna analiza',
      readFullReport: 'Preberi celotno poročilo',
      
      // CTA section
      readyToInvest: 'Pripravljeni na naložbo v kripto?',
      ctaDescription: 'Rezervirajte posvet in spoznajte, kako vam naši regulirani kripto skladi lahko pomagajo doseči vaše naložbene cilje.',
      bookFreeConsultation: 'Rezerviraj brezplačen posvet',
    },

    // About page
    about: {
      seoTitle: 'O nas',
      seoDescription: 'FUTURE MONEY je družba za upravljanje alternativnih investicijskih skladov s sedežem v EU, v Ljubljani, Slovenija. Licencirana za upravljanje kripto naložb.',
      
      companyName: 'FUTURE MONEY,',
      tagline1: 'Družba za upravljanje',
      tagline2: 'alternativnih',
      tagline3: 'investicijskih skladov.',
      
      profileTitle: 'Profil podjetja',
      profileText1: 'FUTURE MONEY, družba za upravljanje alternativnih investicijskih skladov d.o.o.,',
      profileAddress: 'Naslov: Dunajska cesta 101, 1000 Ljubljana, Slovenija',
      profileText2: 'Je bila ustanovljena leta 2019 in je registrirana pri nadzornem organu: Agencija za trg vrednostnih papirjev, Slovenija (ATVP,',
      profileText3: 'FUTURE MONEY je registriran ponudnik storitev virtualnih valut.',
      
      identificationNumber: 'Matična številka',
      taxNumber: 'Davčna številka',
      lei: 'LEI',
      
      teamTitle: 'Spoznajte direktorico',
      teamDescription: 'Izkušena podjetnica, trgovka in strokovnjakinja za finančne naložbe. Moja najvišja prioriteta je zadovoljstvo naših vlagateljev, kar me zelo veseli.',
      directorRole: 'Direktorica',
      directorBio: 'Kripto je priložnost za vse! Izkušena direktorica, predavateljica, mednarodna podjetnica, ustvarjalka kreativnih finančnih produktov, vodja finančne ekipe. Navdušena nad neverjetnimi priložnostmi, ki jih prinašajo sodobne tehnologije. Mednarodna dobaviteljica plemenitih kovin in diamantov.',
    },

    // Contact page
    contact: {
      seoTitle: 'Kontaktirajte nas',
      seoDescription: 'Kontaktirajte FUTURE MONEY za vprašanja o kripto naložbah. Rezervirajte posvet za pogovor o vaših naložbenih ciljih. Nahajamo se v Ljubljani, Slovenija.',
      
      getInTouch: 'Stopite v stik',
      heroTitle: 'Pogovorimo se o vaših',
      heroTitleGold: 'naložbenih ciljih',
      heroDescription: 'Pripravljeni raziskati regulirane kripto naložbene priložnosti? Kontaktirajte nas za rezervacijo posveta ali za več informacij o naših skladih.',
      
      contactInfo: 'Kontaktni podatki',
      contactInfoDesc: 'Dosežite nas preko kateregakoli od naslednjih kanalov. Običajno odgovorimo v 24 delovnih urah.',
      
      officeAddress: 'Naslov pisarne',
      email: 'E-pošta',
      phone: 'Telefon',
      linkedin: 'LinkedIn',
      followLinkedin: 'Sledite nam na LinkedInu',
      
      scheduleConsultation: 'Rezervirajte posvet',
      scheduleDesc: 'Rezervirajte brezplačen posvet za pogovor o vaših naložbenih potrebah.',
      bookNow: 'Rezerviraj zdaj',
      
      sendMessage: 'Pošljite nam sporočilo',
      name: 'Ime',
      yourName: 'Vaše ime',
      yourEmail: 'vasa@eposta.com',
      subject: 'Zadeva',
      selectTopic: 'Izberite temo',
      investmentInquiry: 'Povpraševanje o naložbi',
      fundInformation: 'Informacije o skladu',
      partnership: 'Partnerstvo',
      generalQuestion: 'Splošno vprašanje',
      other: 'Drugo',
      message: 'Sporočilo',
      howCanWeHelp: 'Kako vam lahko pomagamo?',
      sending: 'Pošiljanje...',
      sendMessageBtn: 'Pošlji sporočilo',
      formDisclaimer: 'Z oddajo tega obrazca se strinjate z našo politiko zasebnosti in soglašate, da vas kontaktiramo v zvezi z vašim povpraševanjem.',
      
      messageSent: 'Sporočilo poslano!',
      thankYou: 'Hvala, ker ste nas kontaktirali. Odgovorili vam bomo v 24 delovnih urah.',
      sendAnother: 'Pošlji novo sporočilo',
    },

    // First Crypto Fund page
    fcf: {
      seoTitle: 'Prvi kripto sklad',
      seoDescription: 'Prvi kripto sklad investira v kriptovalute, ki omogočajo generiranje novih kovancev z uporabo naprednih pristopov. Strategija z visokim tveganjem in visoko nagrado.',
      
      fundNotice: 'Investicijski skladi so namenjeni izključno profesionalnim vlagateljem.',
      chartTitle: 'Prvi kripto sklad',
      chartSubtitle: '(FCF graf)',
      loadingChart: 'Nalaganje podatkov grafa...',
      noChartData: 'Podatki grafa še niso na voljo.',
      navUsd: 'VEP (USD)',
      
      strategyTitle: 'Kratek opis strategije:',
      strategyP1: 'Prvi kripto sklad investira v kriptovalute, ki omogočajo generiranje novih kovancev z uporabo naprednih pristopov.',
      strategyP2: 'Zaradi spreminjajočih se tržnih razmer in volatilnosti si sklad prizadeva za doseganje višjih donosov z višjim tveganjem in volatilnostjo.',
      strategyP3: 'Upravljavec sklada bo sredstva sklada razpršil med kriptovalutami, zlasti med izbranimi obetavnimi kriptovalutami, ter različnimi vrstami kripto naložb s ciljem doseganja višjega donosa.',
      strategyP4: 'Strategija upravljanja sklada temelji na premišljenem odzivu na dinamične razmere na trgih kriptovalut, ki pogosto kažejo ekstremno volatilnost in nestabilnost. Cilj strategije je ustvariti privlačne donosne priložnosti za stranke kljub povečanemu tveganju in volatilnosti. Pri oblikovanju in izvajanju portfelja bomo uporabili nabor visoko specializiranih in naprednih pristopov.',
      
      masternodesTitle: 'Masternodi',
      masternodesDesc: 'Ključna komponenta strategije je aktivna uporaba masternodov. Masternodi niso le tehnični elementi, temveč predstavljajo kritičen del omrežja kriptovalut. Poleg svoje vloge pri zagotavljanju varnosti omrežja igrajo pomembno vlogo pri validaciji transakcij, kar povečuje zanesljivost blockchain omrežja. V zameno za shranjevanje in validacijo transakcij bomo prejeli nove (ali dodatne) kovance, kar lahko pozitivno vpliva na donose sklada.',
      
      stakingTitle: 'Staking',
      stakingDesc: 'Strategija vključuje tudi aktivno sodelovanje v procesu stakinga. To pomeni zaklepanje določene količine kriptovalute v denarnici z namenom podpore verodostojnosti in potrjevanja transakcij v omrežju. To omogoča donosnost naših sredstev v obliki nagrad ali obresti, kar prispeva k skupnim donosom naložbene strategije.',
      
      yieldFarmingTitle: 'Yield Farming',
      yieldFarmingDesc: 'V okviru strategije izvajamo strategije yield farminga. To vključuje posojanje ali zagotavljanje likvidnosti v decentraliziranih finančnih protokolih (decentralizirane finance). Ta pristop nam omogoča pridobivanje donosov v obliki novih kovancev ali obresti na vloge, kar dodatno prispeva k potencialnemu donosu naložbe.',
      
      vestingTitle: 'Vesting',
      vestingDesc: 'Za zmanjšanje volatilnosti in zagotavljanje dolgoročne stabilnosti uporabljamo strategijo vestinga, kjer se dodeljene količine kriptovalute postopoma sproščajo v določenem obdobju. Ta premišljen pristop omogoča boljše upravljanje sredstev in zmanjšuje izpostavljenost tržnim nihanjem.',
      
      lpTitle: 'Likvidnostni skladi (LP)',
      lpDesc: 'Sredstva sklada so investirana v likvidnostne sklade ali LP-je, ki delujejo v okviru decentraliziranih finančnih protokolov. Za vstop v te sklade potrebujemo USDC ali USDT na eni strani in kriptovalute na drugi strani, kar nam omogoča sodelovanje v likvidnostnih skladih. To krepi donosni potencial sklada in nam omogoča izkoriščanje različnih naložbenih priložnosti.',
      
      advantagesTitle: 'Prednosti aktivnega upravljanja:',
      advantagesIntro: 'Aktivno upravljanje sredstev našega sklada ponuja številne prednosti, vključno z:',
      
      advantage1Title: 'Diverzifikacija portfelja:',
      advantage1Desc: 'Premišljeno kombiniranje različnih naložbenih pristopov, vključno z masternodi, stakingom, yield farmingom, vestingom in LP naložbami, nam omogoča ustvarjanje dobro razpršenega portfelja. To zmanjšuje tveganje in povečuje potencial za donosnost.',
      
      advantage2Title: 'Generiranje pasivnega dohodka:',
      advantage2Desc: 'Masternodi in staking omogočajo pasivno generiranje novih kovancev, kar prispeva k potencialu za donosnost.',
      
      advantage3Title: 'Dolgoročna stabilnost:',
      advantage3Desc: 'Strategije kot je vesting zagotavljajo dolgoročno stabilnost portfelja, zmanjšujejo izpostavljenost tržni volatilnosti.',
      
      advantage4Title: 'Fleksibilnost:',
      advantage4Desc: 'Aktivno upravljanje nam omogoča prilagajanje portfelja glede na trenutne tržne razmere in nastajajoče priložnosti, ohranjanje naše sposobnosti odzivanja na tržne dinamike.',
      
      advantagesConclusion: 'S tem celovitim pristopom k aktivnemu upravljanju sredstev si prizadevamo, da naš sklad izkoristi priložnosti na trgu kriptovalut in doseže višje donose kljub povečanemu tveganju in volatilnosti na premišljen in profesionalen način.',
      
      technicalTitle: 'Tehnične informacije o Prvem kripto skladu:',
      isinCode: 'ISIN koda',
      securityCode: 'Koda vrednostnega papirja',
      cfiGroup: 'CFI skupina',
      cfiValue: 'Ostalo (Razno) (CM)',
      leiCode: 'LEI koda',
      registrationNumber: 'Matična številka',
      taxNumber: 'Davčna številka',
      fundType: 'Vrsta sklada',
      fundTypeValue: 'odprti alternativni investicijski sklad',
      registeredIn: 'Registriran v',
      registeredInValue: 'Slovenija (EU)',
      supervisoryAuthority: 'Nadzorni organ',
      supervisoryValue: 'Agencija za trg vrednostnih papirjev, Slovenija (ATVP,',
      reporting: 'Poročanje',
      reportingValue: 'Agencija za trg vrednostnih papirjev, Slovenija po neposrednih smernicah Evropskega organa za vrednostne papirje in trge (ESMA)',
      risk: 'Tveganje',
      riskValue: 'Visoko',
      investmentStrategy: 'Naložbena strategija',
      investmentStrategyValue: 'Drugo (kripto)',
      currency: 'Valuta',
      currencyValue: 'Ameriški dolar (USD)',
      minInvestment: 'Min. naložba',
      entryFee: 'Vstopna provizija',
      exitFee: 'Izstopna provizija',
      transactionCost: 'Transakcijski stroški',
      adminFee: 'Administrativna provizija',
      managementFee: 'Provizija za upravljanje',
      otherFees: 'Druge provizije',
      profitSharing: 'Delitev dobička',
      profitSharingValue: '60% vlagateljem, 40% upravljavcu sklada (High Water Mark, mesečni izračun, četrtletna ponastavitev)',
      cutOffDate: 'Presečni datum',
      cutOffDateValue: '(za izračun VEP, pologov in dvigov): zadnji dan v mesecu',
      
      paymentTitle: 'Navodila za plačilo:',
      iban: 'IBAN',
      bicSwift: 'BIC / SWIFT',
      bank: 'Banka',
      manager: 'Upravljavec',
      address: 'Naslov',
    },

    // Blog page
    blog: {
      seoTitle: 'Blog - Tržni vpogledi in tedenska poročila',
      seoDescription: 'Bodite obveščeni z najnovejšo analizo trga kriptovalut FUTURE MONEY, naložbenimi vpogledi in tedenskimi Bitcoin in kripto poročili.',
      
      ourBlog: 'Naš blog',
      heroTitle: 'Tržni vpogledi in',
      heroTitleGold: 'tedenska poročila',
      heroDescription: 'Bodite obveščeni z našo najnovejšo tržno analizo, naložbenimi vpogledi in tedenskimi poročili o kriptovalutah.',
      
      allPosts: 'Vse objave',
      weeklyReports: 'Tedenska poročila',
      marketAnalysis: 'Tržna analiza',
      news: 'Novice',
      education: 'Izobraževanje',
      
      loadingPosts: 'Nalaganje objav...',
      noPostsFound: 'Objave niso najdene',
      checkBackSoon: 'Kmalu preverite za novo vsebino.',
      readMore: 'Preberi več',
      
      // BlogPost page
      loadingPost: 'Nalaganje objave...',
      postNotFound: 'Objava ni najdena',
      postNotFoundDesc: 'Objava, ki jo iščete, ne obstaja ali je bila odstranjena.',
      backToBlog: 'Nazaj na blog',
      backToAllPosts: 'Nazaj na vse objave',
      views: 'ogledov',
      share: 'Deli',
      shareArticle: 'Deli članek',
      linkCopied: 'Povezava kopirana v odložišče!',
    },

    // Footer
    footer: {
      description: 'Družba za upravljanje alternativnih investicijskih skladov, specializirana za regulirane kripto naložbene rešitve za profesionalne vlagatelje.',
      quickLinks: 'Hitre povezave',
      ourFunds: 'Naši skladi',
      hedgeFund: 'Hedge sklad',
      bestCryptoIndex: 'Najboljši kripto indeksni sklad',
      contact: 'Kontakt',
      privacyPolicy: 'Politika zasebnosti',
      termsOfService: 'Pogoji storitve',
      designedBy: 'Oblikoval Noctrify',
      allRightsReserved: 'Vse pravice pridržane.',
      disclaimer: 'Investicijski skladi so namenjeni izključno profesionalnim vlagateljem. Pretekla uspešnost ne nakazuje prihodnjih rezultatov.',
    },
  },
};

export default translations;
